var _process$env$_PACKAGE, _process$env$_PACKAGE2;
var packageName = (_process$env$_PACKAGE = "@atlassian/browser-storage-controls") !== null && _process$env$_PACKAGE !== void 0 ? _process$env$_PACKAGE : '';
var packageVersion = (_process$env$_PACKAGE2 = "6.11.3") !== null && _process$env$_PACKAGE2 !== void 0 ? _process$env$_PACKAGE2 : '';
export { packageName, packageVersion };